import {createApi} from "@reduxjs/toolkit/query/react";
import {Response} from "../../types/response/Response";
import {apiQueryV2} from "../utils/Extensions";
import {OrderDTO, OrdersGetRequestBody} from "../../types/order/OrderDTO";
import {LOCAL_STORAGE_ORIGINAL_SIGN_LIST} from "../../utils/constants/LocalStorage";


export const orderApi = createApi({
    reducerPath: "order",
    baseQuery: apiQueryV2,
    tagTypes: ["orders", "productList"],
    endpoints: builder => ({
        getOrders: builder.query<Response<OrderDTO[]>, Partial<OrdersGetRequestBody>>({
            query: ({branchId}) => `/organizations/${branchId}/deliveries`,
            providesTags: ["orders"],
            extraOptions: {maxRetries: 3},
            transformResponse: (response: Response<OrderDTO[]>): Response<OrderDTO[]> => {
                if (!response?.data) {
                    return response
                }
                const localstorageData = localStorage.getItem(LOCAL_STORAGE_ORIGINAL_SIGN_LIST)
                const scannedOrderIdList = localstorageData && JSON.parse(localstorageData) as string[]
                const data = response
                    ?.data
                    ?.map(item => ({...item, isScanned: scannedOrderIdList?.includes(item.iikoId)}))
                return {...response, data}
            }
        })
    })
})

export const {
    useGetOrdersQuery,
    useLazyGetOrdersQuery,
} = orderApi